// 处理请求返回结果（学院接口数据结构）
// 成功：{data: xxx}
// 失败：{error: msg}
export const handleLearningRequest = (result) => {
  if (!result) return { error: 'unknown' };

  if (result.code === 200) {
    return { data: result.data, _updated: result._updated };
  }
  return { error: result.msg };
};

// 转换大搜返回的数据
export const mapAcademyResources = (resources) => {
  const res = [];
  if (!resources || !resources.length) return res;

  resources.forEach((item) => {
    const { more_obj: more, post_video_obj: postVideo, ...rest } = item;
    const newItem = { ...rest };

    if (more) {
      newItem['more'] = more;
    }
    if (postVideo) {
      newItem['post_video'] = postVideo;
    }

    res.push(newItem);
  });

  return res;
};
